import Subscription from '../pages/Subscription.vue';
import SubscriptionForm from '../pages/SubscriptionForm.vue';

const subscriptionRoutes = [
  {
    path: '/financial-management/subscription',
    name: 'مدیریت حق اشتراک',
    component: Subscription,
  },
  {
    path: '/financial-management/subscription/payment/:id',
    name: 'پرداخت حق اشتراک',
    component: SubscriptionForm,
  },
  {
    path: '/financial-management/subscription/form',
    name: 'ایجاد حق اشتراک',
    component: SubscriptionForm,
  },
];
export default subscriptionRoutes;
